import React from "react";
import { Tooltip } from "react-tooltip";
import moment from "moment";
import "../timelineDiagram/timelineDiagram.scss";
import "react-tooltip/dist/react-tooltip.css";

const TimelineDiagram = ({ data = [], date }) => {
  if (!data || !data.length) {
    return <div className="timelineDiagram">Keine Daten</div>;
  }

  const toLocalMoment = (ts) => moment.parseZone(ts).local();

  const createSegments = (points) => {
    const sorted = [...points].sort((a, b) =>
      toLocalMoment(a.timestamp).diff(toLocalMoment(b.timestamp))
    );

    const segments = [];

    let current = {
      ignition: Number(sorted[0].ignition),
      start: toLocalMoment(sorted[0].timestamp),
    };

    for (let i = 1; i < sorted.length; i++) {
      const item = sorted[i];
      const m = toLocalMoment(item.timestamp);
      const ignition = Number(item.ignition);

      if (ignition !== current.ignition) {
        segments.push({
          ...current,
          end: m,
        });

        current = {
          ignition,
          start: m,
        };
      }
    }

    const selected = moment(date);
    const today = moment();

    let endOfLast;

    if (selected.isSame(today, "day")) {
      // Heute: bis zur aktuellen Uhrzeit
      endOfLast = today;
    } else {
      // Vergangene Tage: bis Mitternacht des Folgetages
      endOfLast = selected.clone().add(1, "day").startOf("day");
    }

    // Letztes Segment bis zum Tagesende verlängern,
    // unabhängig davon, ob die Zündung EIN oder AUS ist.
    segments.push({
      ...current,
      end: endOfLast,
    });

    return segments;
  };

  const segments = createSegments(data);

  const startTime = moment.min(segments.map((s) => s.start));
  const endTime = moment.max(segments.map((s) => s.end));
  const totalDuration = endTime.diff(startTime);

  if (totalDuration <= 0) {
    return (
      <div className="timelineDiagram">
        Keine Zeitspanne vorhanden
      </div>
    );
  }

  return (
    <div className="timelineDiagram">
      <Tooltip id="timeLineTooltip" place="top" />

      <div className="timelineWrapper">
        {segments.map((segment, i) => {
          const left =
            (segment.start.diff(startTime) / totalDuration) * 100;

          const width =
            (segment.end.diff(segment.start) / totalDuration) * 100;

          const colorState =
            segment.ignition === 1 ? "#03b73c" : "#cd071e";

          return (
            <div
              key={i}
              className="timelineSegment"
              style={{
                left: `${left}%`,
                width: `${width}%`,
                backgroundColor: colorState,
              }}
              data-tooltip-id="timeLineTooltip"
              data-tooltip-content={
                `${segment.ignition === 1 ? "Ein" : "Aus"} ` +
                `${segment.start.format("HH:mm")} - ` +
                `${segment.end.format("HH:mm")}`
              }
            >
              <span>
                {segment.ignition === 1 ? "Ein" : "Aus"}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TimelineDiagram;